export default __webpack_public_path__ + "static/media/GothamRounded-Medium.10d88929.otf";